import { EdgeCompleteOnboardingRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { CompleteOnboarding } from '@/modules/auth/use-cases'

export function makeCompleteOnboarding(): CompleteOnboarding {
  return new EdgeCompleteOnboardingRepository(makeSupabaseEdgeHttpClient()).execute
}
